var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 45,
    viewBox: "0 0 71 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2516 29.4338L68.9154 0.616876C68.3866 0.264376 67.6816 0 66.9766 0H3.52664C2.82164 0 2.11664 0.264376 1.58789 0.616876L35.2516 29.4338Z",
    fill: "#FFEE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5412 32.0774C36.2194 33.2231 34.2806 33.2231 32.9588 32.0774L0 3.96557V40.5374C0 42.4762 1.58625 44.0624 3.525 44.0624H66.975C68.9138 44.0624 70.5 42.4762 70.5 40.5374V3.87744L37.5412 32.0774Z",
    fill: "#FFEE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.b8f11dc3c84741ccfb9e48ef61ff811c.svg";
export { ForwardRef as ReactComponent };